export default __webpack_public_path__ + "static/media/nattu-adnan-atSUvc1hMwk-unsplash.c866d607.jpg";